"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var decorationRouter = {
  path: '/decoration',
  component: _layout.default,
  redirect: '/decoration/lead',
  name: 'Decoration',
  alwaysShow: true,
  meta: {
    title: '装企',
    icon: 'clipboard'
  },
  children: [{
    path: 'lead',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/lead/index'));
      });
    },
    name: 'DecorationLead',
    meta: {
      title: '意向线索',
      icon: ''
    }
  }, {
    path: 'project',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/project/index'));
      });
    },
    name: 'DecorationProject',
    meta: {
      title: '工地项目',
      icon: ''
    }
  }, {
    path: 'order-delivery',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/order-delivery/index'));
      });
    },
    name: 'DecorationOrderDelivery',
    meta: {
      title: '订单交付',
      icon: ''
    }
  }, {
    path: 'schedule',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/schedule/index'));
      });
    },
    name: 'DecorationSchedule',
    meta: {
      title: '工期管理',
      icon: ''
    }
  }, {
    path: 'document',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/document/index'));
      });
    },
    name: 'DecorationDocument',
    meta: {
      title: '工地单据',
      icon: ''
    }
  }, {
    path: 'report',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/report/index'));
      });
    },
    name: 'DecorationReport',
    meta: {
      title: '工地日记',
      icon: ''
    }
  }, {
    path: 'camera',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/camera/index'));
      });
    },
    name: 'DecorationCamera',
    meta: {
      title: '工地摄像头',
      icon: ''
    }
  }, {
    path: 'material',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/material/index'));
      });
    },
    name: 'DecorationMaterial',
    meta: {
      title: '材料订单',
      icon: ''
    }
  }, {
    path: 'order-settlement',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/order-settlement/index'));
      });
    },
    name: 'DecorationOrderSettlement',
    meta: {
      title: '订单结算',
      icon: ''
    }
  }, {
    path: 'todo',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/todo/index'));
      });
    },
    name: 'DecorationTodo',
    meta: {
      title: '待办中心',
      icon: ''
    }
  }, {
    path: 'work-order',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/work-order/index'));
      });
    },
    name: 'DecorationWorkOrder',
    meta: {
      title: '服务工单',
      icon: ''
    }
  }, {
    path: 'review',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/review/index'));
      });
    },
    name: 'DecorationReview',
    meta: {
      title: '点评投诉',
      icon: ''
    }
  }, {
    path: 'ledger',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/ledger/index'));
      });
    },
    name: 'DecorationLedger',
    meta: {
      title: '经营账本',
      icon: ''
    }
  }, {
    path: 'kpi',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/kpi/index'));
      });
    },
    name: 'DecorationKpi',
    meta: {
      title: 'KPI奖罚',
      icon: ''
    }
  }, {
    path: 'partner',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/partner/index'));
      });
    },
    name: 'DecorationPartner',
    meta: {
      title: '合作方',
      icon: ''
    }
  }, {
    path: 'company-supplier',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/company-supplier/index'));
      });
    },
    name: 'DecorationCompanySupplier',
    meta: {
      title: '供应商合作',
      icon: ''
    }
  }, {
    path: 'ad',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/ad/index'));
      });
    },
    name: 'DecorationAd',
    meta: {
      title: '投流计划',
      icon: ''
    }
  }, {
    path: 'campaign',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/campaign/index'));
      });
    },
    name: 'DecorationCampaign',
    meta: {
      title: '营销活动',
      icon: ''
    }
  }, {
    path: 'referral',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/referral/index'));
      });
    },
    name: 'DecorationReferral',
    meta: {
      title: '推荐裂变',
      icon: ''
    }
  }, {
    path: 'staff',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/staff/index'));
      });
    },
    name: 'DecorationStaff',
    meta: {
      title: '权限设置',
      icon: ''
    }
  }, {
    path: 'content',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/content/index'));
      });
    },
    name: 'DecorationContent',
    meta: {
      title: '案例内容',
      icon: ''
    }
  }, {
    path: 'package',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/package/index'));
      });
    },
    name: 'DecorationPackage',
    meta: {
      title: '装修套餐',
      icon: ''
    }
  }, {
    path: 'ai',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/ai/index'));
      });
    },
    name: 'DecorationAi',
    meta: {
      title: 'AI种草',
      icon: ''
    }
  }, {
    path: 'behavior',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/behavior/index'));
      });
    },
    name: 'DecorationBehavior',
    meta: {
      title: '客户行为',
      icon: ''
    }
  }, {
    path: 'asset',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/asset/index'));
      });
    },
    name: 'DecorationAsset',
    meta: {
      title: '素材资产',
      icon: ''
    }
  }, {
    path: 'store',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/store/index'));
      });
    },
    name: 'DecorationStore',
    meta: {
      title: '店装配置',
      icon: ''
    }
  }, {
    path: 'dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/dashboard/index'));
      });
    },
    name: 'DecorationDashboard',
    meta: {
      title: '经营大屏',
      icon: ''
    }
  }, {
    path: 'identity',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/identity/index'));
      });
    },
    name: 'DecorationIdentity',
    meta: {
      title: '我的账号',
      icon: ''
    }
  }, {
    path: 'warning',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/warning/index'));
      });
    },
    name: 'DecorationWarning',
    meta: {
      title: '预警',
      icon: ''
    }
  }, {
    path: 'setting',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/setting/index'));
      });
    },
    name: 'DecorationSetting',
    meta: {
      title: '设置',
      icon: ''
    }
  }, {
    path: 'notification',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/notification/index'));
      });
    },
    name: 'DecorationNotification',
    meta: {
      title: '通知',
      icon: ''
    }
  }, {
    path: 'outlet',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/outlet/index'));
      });
    },
    name: 'DecorationOutlet',
    meta: {
      title: '门店',
      icon: ''
    }
  }, {
    path: 'follow-log',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/follow-log/index'));
      });
    },
    name: 'DecorationFollowLog',
    meta: {
      title: '跟进日志',
      icon: ''
    }
  }, {
    path: 'approval',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/approval/index'));
      });
    },
    name: 'DecorationApproval',
    meta: {
      title: '审批',
      icon: ''
    }
  }, {
    path: 'hotline',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/hotline/index'));
      });
    },
    name: 'DecorationHotline',
    meta: {
      title: '品牌热线',
      icon: ''
    }
  }, {
    path: 'platform-activity',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/platform-activity/index'));
      });
    },
    name: 'DecorationPlatformActivity',
    meta: {
      title: '平台活动',
      icon: ''
    }
  }, {
    path: 'order',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/order/index'));
      });
    },
    name: 'DecorationOrder',
    meta: {
      title: '订单列表',
      icon: ''
    }
  }, {
    path: 'purchase',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/purchase/index'));
      });
    },
    name: 'DecorationPurchase',
    meta: {
      title: '采购列表',
      icon: ''
    }
  }, {
    path: 'group-purchase',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/group-purchase/index'));
      });
    },
    name: 'DecorationGroupPurchase',
    meta: {
      title: '我的集采',
      icon: ''
    }
  }, {
    path: 'pricing',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/pricing/index'));
      });
    },
    name: 'DecorationPricing',
    meta: {
      title: '销售定价',
      icon: ''
    }
  }, {
    path: 'customer-pricing',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/customer-pricing/index'));
      });
    },
    name: 'DecorationCustomerPricing',
    meta: {
      title: '客户定价',
      icon: ''
    }
  }, {
    path: 'alliance-product',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/alliance-product/index'));
      });
    },
    name: 'DecorationAllianceProduct',
    meta: {
      title: '联盟商品',
      icon: ''
    }
  }, {
    path: 'merchant-auth',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/merchant-auth/index'));
      });
    },
    name: 'DecorationMerchantAuth',
    meta: {
      title: '老商家授权',
      icon: ''
    }
  }, {
    path: 'shop-status',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/shop-status/index'));
      });
    },
    name: 'DecorationShopStatus',
    meta: {
      title: '歇业关店',
      icon: ''
    }
  }, {
    path: 'open-guide',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/open-guide/index'));
      });
    },
    name: 'DecorationOpenGuide',
    meta: {
      title: '开店指南',
      icon: ''
    }
  }, {
    path: 'points-mall',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/points-mall/index'));
      });
    },
    name: 'DecorationPointsMall',
    meta: {
      title: '积分商城',
      icon: ''
    }
  }, {
    path: 'platform-rule',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/platform-rule/index'));
      });
    },
    name: 'DecorationPlatformRule',
    meta: {
      title: '平台规则',
      icon: ''
    }
  }, {
    path: 'designer-recruit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/designer-recruit/index'));
      });
    },
    name: 'DecorationDesignerRecruit',
    meta: {
      title: '招募设计师',
      icon: ''
    }
  }, {
    path: 'doc-download',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/doc-download/index'));
      });
    },
    name: 'DecorationDocDownload',
    meta: {
      title: '文档下载',
      icon: ''
    }
  }, {
    path: 'owner-apply',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/owner-apply/index'));
      });
    },
    name: 'DecorationOwnerApply',
    meta: {
      title: '申请为负责人',
      icon: ''
    }
  }, {
    path: 'referral-rule',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/referral-rule/index'));
      });
    },
    name: 'DecorationReferralRule',
    meta: {
      title: '推荐规则',
      icon: ''
    }
  }, {
    path: 'ad-slot',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/ad-slot/index'));
      });
    },
    name: 'DecorationAdSlot',
    meta: {
      title: '投流位',
      icon: ''
    }
  }, {
    path: 'mall-category',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/mall-category/index'));
      });
    },
    name: 'DecorationMallCategory',
    meta: {
      title: '分类展示',
      icon: ''
    }
  }, {
    path: 'renovation-plan',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/renovation-plan/index'));
      });
    },
    name: 'DecorationRenovationPlan',
    meta: {
      title: '装修计划',
      icon: ''
    }
  }, {
    path: 'basic-profile',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/basic-profile/index'));
      });
    },
    name: 'DecorationBasicProfile',
    meta: {
      title: '基础资料',
      icon: ''
    }
  }, {
    path: 'journey',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/journey/index'));
      });
    },
    name: 'DecorationJourney',
    meta: {
      title: '我的历程',
      icon: ''
    }
  }, {
    path: 'site-basic',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/site-basic/index'));
      });
    },
    name: 'DecorationSiteBasic',
    meta: {
      title: '工地基础信息',
      icon: ''
    }
  }, {
    path: 'site-team',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/site-team/index'));
      });
    },
    name: 'DecorationSiteTeam',
    meta: {
      title: '装修团队',
      icon: ''
    }
  }, {
    path: 'supervision-team',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/supervision-team/index'));
      });
    },
    name: 'DecorationSupervisionTeam',
    meta: {
      title: '监理团队',
      icon: ''
    }
  }, {
    path: 'renovation-loan',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/decoration/renovation-loan/index'));
      });
    },
    name: 'DecorationRenovationLoan',
    meta: {
      title: '装修贷',
      icon: ''
    }
  }]
};
var _default = exports.default = decorationRouter;